"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var dsvg_1 = require("../dsvg");
var watermark_1 = require("../watermark");
var formatdata_1 = require("./formatdata");
var default_options = {
    fontsize: 12,
    interaction: true,
    refreshTime: 60000,
    padding: {
        t: 20,
        b: 20,
        l: 60,
        r: 20
    }
};
/**
 * 折线
 */
var Line = /** @class */ (function () {
    function Line(options) {
        // console.log(options)
        this.options = Object.assign({}, default_options, options);
        // this.destory()
    }
    Line.prototype.draw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var y_datas, x_datas;
            return __generator(this, function (_a) {
                y_datas = this.options.yaxis;
                x_datas = this.options.xaxis;
                // 接口数据
                // let apidata = await RZRQLineData() as any;
                // console.log(apidata)
                // y_datas = Object.assign(y_datas,{data:apidata.data})
                // x_datas = Object.assign(x_datas,{data:apidata.time})
                // let y_datas = res.data
                // let x_datas = res.time
                this.commondata = (0, formatdata_1.formatdata)(this.options, y_datas.data);
                //初始化svg
                this.container = document.createElement("div");
                this.container.className = "_emui_quote_chart";
                this.container.style.width = this.options.width + "px";
                this.container.style.height = this.options.height + "px";
                this.options.container.appendChild(this.container);
                this.svg = new dsvg_1.DSVG(this.container, this.options.width, this.options.height);
                this.container.style.fontSize = this.options.fontsize + "px";
                drawImg(this.svg, {
                    y_datas: y_datas,
                    x_datas: x_datas
                }, this.commondata, this.options, this.container);
                return [2 /*return*/];
            });
        });
    };
    return Line;
}());
exports.Line = Line;
function drawImg(svg, data, commondata, options, container) {
    // 画矩形
    drawLineRect(svg, options, commondata);
    // 画Y虚线
    drawGridYLine(svg, options, commondata);
    // 画纵坐标
    drawPointY(svg, options, commondata);
    // 画横坐标
    drawPointX(svg, data.x_datas.data, options, commondata);
    // 画折线
    drawBrokenLine(svg, options, data.y_datas.data, commondata);
    // 画折线区域颜色填充
    if (options.shadow && options.shadow.show) {
        drawShadow(svg, options, data.y_datas.data, commondata);
    }
    // 交互事件
    if (options.interaction) {
        bindEvent(container, data, options, commondata);
    }
    //水印
    //  drawWaterMark(svg.ele,120,26,(options.width - 120) / 2, (options.height - 26) / 2)
    (0, watermark_1.drawWaterMark)(svg.ele, 100, 20, (options.width - 100) - options.padding.r - 5, options.padding.t + 10);
}
/**
 * 画图区边框
 */
function drawLineRect(svg, options, commondata) {
    var outborder = svg.Rect(commondata.yPointWidth, options.padding.t, options.width - options.padding.l - options.padding.r, options.height - options.padding.b - options.padding.t);
    outborder.attr({ class: 'inner_border' });
}
/**
 * 画折线
 */
function drawBrokenLine(svg, options, data, commondata) {
    var x_scale = commondata.x_scale, y_scale = commondata.y_scale, yAxisMax = commondata.yAxisMax, yPointWidth = commondata.yPointWidth;
    svg.Path(data.map(function (v, index) {
        return {
            x: index * x_scale + yPointWidth,
            y: (yAxisMax - v) * y_scale + options.padding.t
        };
    })).attr({ class: 'line_path' });
}
/**
 * 颜色填充
 */
function drawShadow(svg, options, data, commondata) {
    var x_scale = commondata.x_scale, y_scale = commondata.y_scale, yAxisMax = commondata.yAxisMax, yPointWidth = commondata.yPointWidth;
    var padding = options.padding, height = options.height, shadow = options.shadow;
    var path_arr = [{ x: padding.l + 1, y: height - padding.b }];
    data.forEach(function (v, index) {
        path_arr.push({
            x: index * x_scale + yPointWidth,
            y: (yAxisMax - v) * y_scale + options.padding.t + 1
        });
    });
    path_arr.push({
        x: (data.length - 1) * x_scale + yPointWidth,
        y: height - padding.b
    });
    svg.Path(path_arr).attr({ class: 'line_path_shadow', fill: 'url("#gradientcolor")' });
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    defs.innerHTML = "\n    <linearGradient id=\"gradientcolor\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\">\n      <stop offset=\"0%\" stop-color=".concat(shadow.color.t, " />\n      <stop offset=\"100%\" stop-color=").concat(shadow.color.b, " />\n    </linearGradient>");
    svg.ele.appendChild(defs);
}
/**
 * y轴横向虚线
 * @param svg
 * @param options
 * @param commondata
 */
function drawGridYLine(svg, options, commondata) {
    var padding = options.padding;
    var yPointWidth = commondata.yPointWidth, yPointUnit = commondata.yPointUnit;
    for (var i = 0; i < options.yaxis.pointnum - 2; i++) {
        svg.HLine(yPointWidth, (options.height - padding.b) - yPointUnit * (i + 1), options.width - padding.l - padding.r).attr({ class: 'grid_dash_line' });
    }
}
/**
 * 纵坐标
 */
function drawPointY(svg, options, commondata) {
    var height = options.height, fontsize = options.fontsize, padding = options.padding;
    var yAxisMin = commondata.yAxisMin, yAxisMax = commondata.yAxisMax;
    var diff = (yAxisMax - yAxisMin) / (options.yaxis.pointnum - 1); // y轴相邻数值差值
    for (var i = 0; i < options.yaxis.pointnum; i++) {
        var shift = i == 0 ? 5 : 1; // y坐标偏移量
        var txt = svg.Text(5, (height - commondata.yPointUnit * i + fontsize / 2 - shift) - padding.b);
        txt.attr({ class: 'point_txt' });
        txt.ele.textContent = String((yAxisMin + i * diff).toFixed(2));
    }
}
/**
 * 横坐标
 */
function drawPointX(svg, data, options, commondata) {
    var x_scale = commondata.x_scale;
    var padding = options.padding, height = options.height, fontsize = options.fontsize;
    for (var i = 0; i < data.length; i++) {
        if (data[i].show) {
            // let txt_w = txt.ele.getBoundingClientRect().width
            var txt = svg.Text(i * x_scale + options.padding.l - 35, height - (padding.b - fontsize) / 2);
            txt.attr({ class: 'point_txt' });
            txt.ele.textContent = data[i].name;
        }
        // 纵向虚线
        if (data[i].showline) {
            svg.VLine(i * x_scale + options.padding.l, padding.t, height - padding.b - padding.t).attr({ class: 'grid_dash_line' });
        }
    }
}
/**
 * 绑定交互事件
 */
function bindEvent(container, data, options, commondata) {
    var padding = options.padding, height = options.height, width = options.width;
    var x_scale = commondata.x_scale, y_scale = commondata.y_scale, yAxisMax = commondata.yAxisMax;
    var linerect = document.createElement('div');
    linerect.className = '_ui_chart_ctr';
    linerect.style.cssText = "\n    background:rgba(0,0,0,0);\n    width:".concat((width - padding.l - padding.r), "px;\n    left:").concat(padding.l, "px;\n    top:").concat(padding.t, "px;\n    height:").concat((height - padding.t - padding.b), "px\n    ");
    container.appendChild(linerect);
    // x轴左右移动虚线
    var x_move_line = document.createElement('div');
    x_move_line.className = 'x_move_line';
    x_move_line.style.cssText = "top:1px;height:".concat((options.height - padding.t - padding.b), "px");
    linerect.appendChild(x_move_line);
    // 浮窗信息框
    var tip_info_div = document.createElement('div');
    tip_info_div.className = "_ui_tip_info";
    linerect.appendChild(tip_info_div);
    // xy交汇点
    var xy_dot_div = document.createElement('div');
    xy_dot_div.className = "xy_dot_div";
    linerect.appendChild(xy_dot_div);
    var trends = data.y_datas.data;
    linerect.addEventListener('mousemove', function (e) {
        var cur_index = Math.round((e.offsetX - 2) / x_scale);
        // console.info(cur_index)
        x_move_line.style.display = 'none';
        if (cur_index < 0 || cur_index >= trends.length) {
            // console.info('sdfsdfsdfsdfsdfsdffs')
            if (x_move_line.style.display == 'none') {
                return false;
            }
            x_move_line.style.display = 'none';
            return false;
        }
        x_move_line.style.display = 'block';
        x_move_line.style.left = e.offsetX + 'px';
        var y = (yAxisMax - trends[cur_index]) * y_scale;
        var dot_w = xy_dot_div.getBoundingClientRect().width || 15;
        xy_dot_div.style.cssText = "\n      display:block;left:".concat(e.offsetX - dot_w / 2, "px;top:").concat(y - dot_w / 2, "px\n    ");
        var cur_time = data.x_datas.data[cur_index].name;
        var cur_val = trends[cur_index];
        var rect_tip = tip_info_div.getBoundingClientRect();
        tip_info_div.innerHTML = "<p class=\"_tip_txt\">".concat(cur_time, "</p><p class=\"_tip_txt\">").concat(data.y_datas.title, "\uFF1A<span class=\"red\">").concat(cur_val, " ").concat(data.y_datas.subfix, "</span></p>");
        // let tip_left = e.offsetX < (width - padding.l - padding.r) / 2 ? e.offsetX + 10 : e.offsetX - rect_tip.width - 10
        // tip_info_div.style.cssText = `display:block;top:${y - rect_tip.height / 2}px;left:${tip_left}px` 
        var tip_right = width - padding.l - e.offsetX - 10;
        var tip_left = e.offsetX + 10;
        if (e.offsetX < (width - padding.l - padding.r) / 2) {
            tip_info_div.style.cssText = "display:block;top:".concat(y - rect_tip.height / 2, "px;left:").concat(tip_left, "px");
        }
        else {
            tip_info_div.style.cssText = "display:block;top:".concat(y - rect_tip.height / 2, "px;right:").concat(tip_right, "px");
        }
    });
    linerect.addEventListener('mouseleave', function () {
        // console.info('mouseleave')
        // if (x_move_line.style.display == 'none') return false
        x_move_line.style.display == 'none';
        x_move_line.style.display = 'none';
        tip_info_div.style.display = 'none';
        xy_dot_div.style.display = 'none';
    });
    x_move_line.addEventListener('mousemove', function (e) {
        e.stopPropagation();
    });
    xy_dot_div.addEventListener('mousemove', function (e) {
        e.stopPropagation();
    });
}
